import { Customer } from '@medusajs/medusa'
import { useCallback, useEffect, useState } from 'react'

/** Return a boolean for whether or not the provided customer's account
 * has been set up. */
function useCustomerSetUpCheck(customer?: Omit<Customer, 'password_hash'>) {
  const [loading, setLoading] = useState(false)
  const [isSetUp, setIsSetUp] = useState(false)
  const checkIsSetUp = useCallback(async () => {
    setLoading(true)
    try {
      if (customer) {
        const isSetUp =
          customer.shipping_addresses.length > 0 && !!customer.billing_address
        setIsSetUp(isSetUp)
      } else {
        setIsSetUp(false)
      }
    } catch (err) {
      setIsSetUp(false)
    } finally {
      setLoading(false)
    }
  }, [customer])

  useEffect(() => {
    checkIsSetUp()
  }, [checkIsSetUp])

  return {
    isSetUp,
    loading,
  }
}

export default useCustomerSetUpCheck
